/**
 * Created by Vladislav on 28.03.2025.
 */

const Merge2CupTutorial = function () {
    return new TutorialScenario("merge2_cup_tutorial", {
        listSteps: function () {
            return [
                Merge2TutorialHelper.createClickUnitStep({
                    unit: Merge2CupTutorial.tutorialUnit,
                    delay: 3,
                    text: "Merge2.CupTutorial1"
                }),
                Merge2TutorialHelper.createClickUnitStep({
                    unit: Merge2CupTutorial.tutorialUnit,
                    text: "Merge2.CupTutorial2"
                }),

                Merge2TutorialHelper.createClickUnitStep({
                    unit: Merge2CupTutorial.tutorialUnit,
                    text: "Merge2.CupTutorial3"
                })
            ];
        },
        onStart: function () {
            cleverapps.forces.saveForce(Forces.MERGE2_CUP_TUTORIAL);
        },
        isAvailable: function () {
            if (cleverapps.forces.isShown(Forces.MERGE2_CUP_TUTORIAL) || cleverapps.config.demoMode) {
                return false;
            }

            if (!Merge2.current || !Merge2.current.isGameMode()) {
                return false;
            }

            const unit = Merge2.current.field.listAvailableUnits(Merge2CupTutorial.tutorialUnit).filter((unit) => !unit.isGrounded())[0];

            return unit && unit.onGetView() && unit.findComponent(CupComponent).isFull() && Merge2.current.field.countEmptySlots() >= 3;
        }
    });
};

Merge2CupTutorial.tutorialUnit = {
    code: "A",
    stage: 0
};